import LifecycleMap from "./LifecycleMap";

export default LifecycleMap;
